import { Directive, Input, ElementRef, OnChanges, OnInit } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the WebComponentDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[webComponent]', // Attribute selector
  exportAs: 'webComponent',
})
export class WebComponentDirective implements OnChanges {
  @Input() attrs = {};

  constructor(public element: ElementRef) {}

  ngOnChanges() {
    this.update();
  }

  update() {
    if (this.element.nativeElement.customSetAttributes) {
      this.element.nativeElement.customSetAttributes(this.attrs);
    } else {
      _.each(this.attrs, (value, key) => {
        this.element.nativeElement[key] = value;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/web-component/web-component.ts